export class CalculationLog {
    notStarted: boolean = true
    description: string = ""
    startTime: Date = new Date()
    endTime: Date = new Date()
    complete: boolean = false
    success: boolean = false
    messages: CalculationLogMessage[] = []
    errorMessage: string = ""
}

export class CalculationLogMessage {
    message: string = ""
    time: Date = new Date()
    logType: "Log" | "Information" | "Warning" | "Error" = "Log"
}
